import { useTheme, type ThemePreference } from '../theme';
import { IconMoon, IconSun, IconSystem } from './icons';

const OPTIONS: { value: ThemePreference; label: string; Icon: typeof IconSun }[] = [
  { value: 'light', label: 'Light', Icon: IconSun },
  { value: 'dark', label: 'Dark', Icon: IconMoon },
  { value: 'system', label: 'Match my system', Icon: IconSystem },
];

/**
 * A segmented control rather than a cycling button: three states are one too
 * many to discover by clicking, and this way the current one is always visible.
 */
export function ThemeToggle({ className = '' }: { className?: string }) {
  const { preference, setPreference } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Colour theme"
      className={`flex items-center gap-0.5 rounded-lg border border-slate-200 p-0.5 dark:border-slate-800 ${className}`}
    >
      {OPTIONS.map(({ value, label, Icon }) => {
        const active = preference === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={label}
            title={label}
            onClick={() => setPreference(value)}
            className={
              active
                ? 'flex h-7 w-7 items-center justify-center rounded-md bg-brand-100 text-brand-800 dark:bg-brand-900/70 dark:text-brand-100'
                : 'flex h-7 w-7 items-center justify-center rounded-md text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-100'
            }
          >
            <Icon className="h-4 w-4" />
          </button>
        );
      })}
    </div>
  );
}
